import { ActionTree, MutationTree } from "vuex";
import MaterialApi from "@/api/MaterialApi";
import { LocallySearchableAsset, IRootState, IMaterialResponse } from "@iloq/shared";
import { pick } from "lodash";
import config from "@/config";

const materialApi = new MaterialApi();

export interface IMaterialState {
  items: IMaterialResponse;
}

const initialState: IMaterialState = {
  items: {} as IMaterialResponse,
};

const filterCategories = (items: IMaterialResponse): IMaterialResponse => {
  const whiteListedCategories = config.get("materialDamWhiteListedCategories") || [];
  const filteredItems = {
    ...items,
    tags: pick(items.tags, whiteListedCategories),
  };
  filteredItems.files = items.files?.map((item) => {
    const filteredItem = { ...item };
    filteredItem.tags = item.tags?.filter((tag) => whiteListedCategories.includes(tag));
    return filteredItem;
  });
  return filteredItems as IMaterialResponse;
};

const actions: ActionTree<IMaterialState, IRootState> = {
  fetchData({ commit, dispatch }, locale: string): void {
    materialApi
      .fetchMaterial(locale)
      .then((items: IMaterialResponse) => {
        const filteredItems = filterCategories(items);
        commit("setItems", filteredItems);
        dispatch(
          "globalSearch/refreshData",
          { assetType: LocallySearchableAsset.material, assets: filteredItems.files },
          { root: true },
        );
      })
      .catch((err) => Promise.reject(err));
  },
};

const mutations: MutationTree<IMaterialState> = {
  setItems(state: IMaterialState, items: IMaterialResponse): void {
    state.items = items;
  },
};

export const materialModule = {
  actions,
  mutations,
  state: initialState,
  namespaced: true,
};
